import { createGlobalStyle } from 'styled-components'
import tw, { styled } from "twin.macro"

export const GlobalStyles = createGlobalStyle`{

  /* GENERAL STYLE */

  ::selection, ::-webkit-selection {
    color: ${tw`bg-transparent text-orange`};
  }


  body{
    ${tw`font-brandon-grotesque`}
    margin:0;

    &.modal-open{

      overflow: hidden;

    }
  }

  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }

}
`;

export const Primary = styled.main`
 ${tw`flex flex-col flex-1 overflow-hidden`}
 
  margin-top: 85px;

  @media (max-width: 640px){
    margin-top: 80px;
  }
  
  h2 {
    ${tw`font-medium text-3xl sm:text-4xl md:text-5xl lg:text-6xl`}
  }
  p, li {
    ${tw`font-medium text-base sm:text-lg md:text-xl lg:text-2xl`}
  }

`;

export const Root = styled.div`
  ${tw`flex flex-col min-h-screen w-full relative`}
`;

